"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@heron-web/material");
var _hopsSdkJs = require("@hps/hops-sdk-js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Render's the input field for order questions
 * 
 * @package HOPS
 * @subpackage OrderQuestions
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class OrderQuestionInput extends _react.default.PureComponent {
  /**
   * Value change handler.
   * 
   * Handles datatype casting, etc.
   * 
   * @param {mixed} value
   * @param {String} questionIdentifier
   * @return {void}
   */
  handleChange = (value, questionIdentifier) => {
    if (this.props.type === _hopsSdkJs.OrderQuestionDataTypes.Number) {
      if (value !== "" && value !== null) {
        value = parseInt(value);
      }
    }
    this.props.onChange(value, questionIdentifier);
  };

  /**
   * Render.
   * 
   * @return {ReactNode}
   */
  render() {
    const sharedProps = {
      color: this.props.color,
      name: this.props.id,
      onChange: this.handleChange,
      required: this.props.required,
      value: this.props.value
    };
    if (this.props.type === _hopsSdkJs.OrderQuestionDataTypes.TrueFalse || this.props.type === _hopsSdkJs.OrderQuestionDataTypes.YesNo) {
      const isTf = this.props.type === _hopsSdkJs.OrderQuestionDataTypes.TrueFalse;
      const options = [{
        label: isTf ? "True" : "Yes",
        value: 1
      }, {
        label: isTf ? "False" : "No",
        value: 0
      }];
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Radio, {
        disabled: this.props.disabled,
        options: options,
        row: true,
        ...sharedProps
      });
    } else if (this.props.type === _hopsSdkJs.OrderQuestionDataTypes.MultipleChoice) {
      const options = this.props.options?.map(option => {
        return {
          id: option.Id,
          label: option.Legend,
          value: option.Id
        };
      }) || [];
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Select, {
        disabled: this.props.disabled,
        label: "Please select...",
        options: options,
        ...sharedProps
      });
    } else {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.TextField, {
        disabled: this.props.disabled,
        maxLength: this.props.type === _hopsSdkJs.OrderQuestionDataTypes.Str ? 250 : undefined,
        multiline: this.props.type === _hopsSdkJs.OrderQuestionDataTypes.Text,
        placeholder: "Type here...",
        rows: this.props.type === _hopsSdkJs.OrderQuestionDataTypes.Text ? 3 : 1,
        type: this.props.type === _hopsSdkJs.OrderQuestionDataTypes.Number ? "number" : "text",
        ...sharedProps,
        value: sharedProps.value?.toString() || ""
      });
    }
  }
  static propTypes = {
    color: _propTypes.default.oneOf(["primary", "secondary"]),
    disabled: _propTypes.default.bool,
    name: _propTypes.default.string,
    onChange: _propTypes.default.func,
    options: _propTypes.default.array,
    required: _propTypes.default.bool,
    type: _propTypes.default.number,
    value: _propTypes.default.any
  };
  static defaultProps = {
    color: "primary",
    disabled: false,
    options: [],
    required: false,
    type: _hopsSdkJs.OrderQuestionDataTypes.Text,
    value: null
  };
}
var _default = OrderQuestionInput;
exports.default = _default;